const ViewInvalidUrl = () => (
  <div className="viewer-screen">
    <p className="title-centered" style={{ color: "black" }}>
      <span className="smile">:(</span>
      Zadaná URL adresa výstavy neexistuje.
    </p>
  </div>
);

export default ViewInvalidUrl;
